import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux'
import * as cartActions from './../../../action/cart';
import { InHomeUtils } from './../../../../src/util/inhomeUtils'
import { updateSCTags } from './../../../service/dtmTag';
import { PAGEACTIVITY,Pages, Service} from './../../../constants/actionType';
import { redirectTo } from './../../../action/redirection';
import { ButtonGroup, TextLink } from '@vds/buttons';
import OrderSummaryReskin from './orderSummary';
import MovesOrderSummary from './MovesOrderSummary';
import ReviewOrderReskin from './ReviewOrder';
import MovesReviewOrder from './MovesReviewOrder';
import * as checkoutAction from './../../../action/checkout'
import * as buildProductAction from './../../../action/buildProduct';
import { logOtherInfo,detailsInfo, catchJSException } from './../../../service/logService'
import { Title } from '@vds/typography';
import { detectClient } from '../../../util/detectClient';
import CloseIcon from '@vds/icons/close';
import SaveMiniCart from '../../header/SaveMiniCart';

const orderSum = props => {
  const { lqState, appState,routerState, cartState,profileCartState, buildProductState, creditCheckState, checkoutState, visitId, dispatch, btnData, progressbar, moveExpState } = props;
  const isMobile = (window.screen.width < 768) ? true : false; 
  const isTablet = (window.screen.width > 767 && window.screen.width < 1025) ? true : false;
  const isStickyCartHeader =  isMobile && ((appState?.flowType !== "MV" && appState?.flowType !== "SUPP" && buildProductState?.stickyheaderfooter) || ((appState?.flowType ==='MV'  && buildProductState?.movesstickyheaderfooter )));
  const isNonStickyCartHeader =  !((appState?.flowType !== "MV" && appState?.flowType !== "SUPP" && buildProductState?.stickyheaderfooter) || ((appState?.flowType ==='MV'  && buildProductState?.movesstickyheaderfooter)));
  const isStickyProgressBar = appState?.flowType !== "MV" && appState?.flowType !== "SUPP" && buildProductState?.stickyProgressbar && ((lqState && lqState?.runtimeKey && lqState?.runtimeKey.enableStickyProgressBar === 'Y'));
  const [position, setPosition] = useState({ x: 0, y: '30vh' });

  const [showMovesOldCart, setShowMovesOldCart] = useState(true);
  
  const [startX, setStartX] = useState(0);
  const [startY, setStartY] = useState(0);

  let dtvMiniOverLayTopSetting = '';
  let streamlineOrdering = window && window.location && window.location.pathname && window.location.pathname.includes('streamlineordering');
  let StremlineMiniCart = props?.lqState?.streamlineLQ ? "stremViewOnlyMini" : "desktopViewOnlyMini"
  let StremlineMiniCartContent = props?.lqState?.streamlineLQ ? "stremMiniCartContent" : "dvMiniCartContent"
  let StremlineMiniCartSticky = props?.lqState?.streamlineLQ ? "StlmMinicartSticky" : "dvMinicartSticky"
  let StremlineMiniCartMobileView = props?.lqState?.streamlineLQ;
  if(isStickyCartHeader){
    dtvMiniOverLayTopSetting='0px';
  }
  else if(isStickyProgressBar && isTablet){
    dtvMiniOverLayTopSetting='4.5vh';
  }

  let dvCartClass = (lqState.isFCPflow ||  (lqState && lqState.hoaFlowDetails && lqState.hoaFlowDetails.isHoaFlow)) ? `topnav_cart-details ${isStickyCartHeader ? 'topnav_cart-detailsStickyCart':'topnav_cart-detailsmini'} ${streamlineOrdering ? 'topnav_cart-detailsminiStreamline' : 'topnav_cart-detailsmini' } padding-all-zero active fcp` : `topnav_cart-details ${isStickyCartHeader ? 'topnav_cart-detailsStickyCart ':'topnav_cart-detailsmini '}padding-all-zero active`;
  let summaryPage = (routerState.location.pathname).indexOf("summary") > -1 ? true : false;
  let checkoutPage = (routerState.location.pathname).indexOf("checkout") > -1 ? true : false;
  let orderSumPage = (routerState.location.pathname).indexOf("ordersummary") > -1 ? true : false;
  let currClient = detectClient();
  const isOrderSummary = window.location.href.includes("/inhome/summary") ? true : false;
  const isMovesFlowOSIthrottle = appState?.flowType === 'MV' &&  !orderSumPage && buildProductState?.movesordersummary;
  const dvCartSumarry = isOrderSummary ? 'OrderSumarryCart' : '';
  const checkoutCartClass = checkoutPage ? 'checkoutPageCartClass' : ' '
  const reskinCartChanges = window.reskinCartChanges === "Y" ? true : false;
  const isTotalSavingsRefresh = lqState && lqState.runtimeKey && lqState.runtimeKey.isTotalSavingsRefresh && lqState.runtimeKey.isTotalSavingsRefresh === "Y" ? true : false ;
  const [draggedState, setDraggedState] = useState(isMobile? true: false);
  
   let hideSelfSetupCheck = false;
  if(InHomeUtils.isNotNull(checkoutState))
  {
      if(checkoutState?.eligibleInstallation === 'TechOnly' && (checkoutState?.selDueDateType_new === "EONTSELFINSTALL" || checkoutState?.selDueDateType === 'EONTSELFINSTALL') ){
          hideSelfSetupCheck = true;
      }
      
  }
  if(orderSumPage) {
      summaryPage = false 
  }
  const fullCartToggle = cartState && cartState.fullCartToggle === 'Y' ? true : false; 

  const isFiosSetup = (action) => {
    cartActions.fiosSetupFee(action, dispatch)
  }

  const onCartSplitBillClick = (action) => {       
      cartActions.splitBillTab(action, dispatch)
  }

  useEffect(() => {       
      !isMobile && window.scrollTo(0,0);      
      dispatch({type:'ON_CLICK_MINICART_ORDER_BUTTON', value:false});      
      let cartOverlayEl = document.getElementById('dvCart-back-overlaymini');
      cartOverlayEl.onclick = onCartClick; 
      
      if (window.navigator.userAgent.toLowerCase().indexOf('edge') !== -1) {
          doCartScrollTop();
          let cartBtnWrapperEl = window.document.querySelector('#dvCart .fiosCartCheckoutButton');
          if (cartBtnWrapperEl) {
              cartBtnWrapperEl.style.width === "100%" ? cartBtnWrapperEl.style.width = "101%" : cartBtnWrapperEl.style.width = "100%";
          }
      }
      onCartSplitBillClick(0);           
      if(!isMobile) {document.body.scrollTop = 0;}

      if(appState.flowType === 'MV'){
        let profilecartPrice = "$0";
        let newCartPrice = "$0";
        if(profileCartState.cartHeader !== null && profileCartState.cartHeader !== undefined && profileCartState.cartHeader.length > 0){
          profilecartPrice = profileCartState.cartHeader[0].monthlyRcPrice !== null ? profileCartState.cartHeader[0].monthlyRcPrice : 0;
        }
        if(cartState.cartHeader !== null && cartState.cartHeader !== undefined && cartState.cartHeader.length > 0){
          newCartPrice = cartState.cartHeader[0].monthlyRcPrice !== null ? cartState.cartHeader[0].monthlyRcPrice : 0
        }
        
        setShowMovesOldCart(!(newCartPrice.indexOf("$0") > -1))
      }
      
          
  }, []); 

  const handleToggleChatButton = (cartOpenState) =>{
    
      const elements = document.getElementsByClassName(
        "LPMcontainer LPMoverlay"
      );
      const lpChat = document.getElementById("lpChat");

      if(cartOpenState){       
        
        //Hide lpChat
        if (lpChat !== undefined || lpChat !== null) {
          if (lpChat?.length === undefined && lpChat?.style !== undefined) {
            lpChat.style.display = "none";
          }
        }
        //Hide Chat button
        if (elements !== undefined || elements !== null) {
          if (elements?.length !== undefined) {
            for (let i = 0; i < elements.length; i++) {
              elements[i].style.display = "none";
            }
          }
        }
      }
      else if(!cartOpenState){
        //Hide lpChat
        if (lpChat !== undefined || lpChat !== null) {
          if (lpChat?.length === undefined && lpChat?.style !== undefined) {
            //lpChat.style = "display:block";
            lpChat.style.display = "block";
          }         
        }
        //Hide Chat button
        if (elements !== undefined || elements !== null) {
          if (elements?.length !== undefined) {
            for (let i = 0; i < elements.length; i++) {
              elements[i].style.display = "block";
            }
          }
          
        }

      }
          
    

  }
  

  useEffect(() =>{   
    if(props?.lqState?.streamlineLQ || isMobile){
      handleToggleChatButton(true);
    }
  },[]);

 

  const doCartScrollTop = () => {
    //scroll by 1px to refresh cart layout (issue on edge)
    let cartEl = window.document.getElementById('dvCart');
    if (cartEl) {
        cartEl.scrollTop === 0 ? cartEl.scrollTop = 1 : cartEl.scrollTop = 0;
    }
  }

  const checkOutRedirection = () => {
    try {
      if ((buildProductState?.enableRoommateScenerioOnOSI) && buildProductState?.roommateOptionSelected === "" && window.location.pathname.includes('ordersummary')) {
        {
          updateSCTags("checkout", "Error - Please complete the required field to proceed")
          onCloseMiniCart(true)
          dispatch({ type: "ROOMMATE_ERROR_CASE", value: true });
          const focusingElem = document?.getElementById('roommateSectionOSI');
          focusingElem?.scrollIntoView({ behavior: "smooth" })
        }
      } else {
        updateSCTags("review order")
        cartActions.cartToggle('', dispatch, appState.visitId, buildProductState);
        updateSCTags("checkout – Order Summary");
        redirectTo(Pages.Checkout, dispatch);
      }
    }
    catch (error) {
      console.log(error, "Error in CheckoutRedirection")
    }
  }

  const linkEditTagCall = (etag) => {      
   
    updateSCTags(etag);
    
      setTimeout(()=>{  
  if(props?.lqState?.streamlineLQ){  
    redirectTo(Pages.StreamLine, dispatch);
  }else{
    redirectTo(Pages.BuildProduct, dispatch);
  }
    },500);      
    
  }

  const checkUpsellRecommendation = () => {
    let proceedToCheckoutForRAF = true;
    let proceedToCheckoutForFF = true;
    let proceedToCheckoutForVZC = true;
    let proceedToCheckout=true;
    let youtubeInCart = (InHomeUtils.isNotNull(buildProductState.tv) && InHomeUtils.isNotNull(buildProductState.tv.selectedProduct) && InHomeUtils.isNotNull(buildProductState.tv.selectedProduct.prodType) && buildProductState.tv.selectedProduct.prodType === Service.streamServ);
    if (buildProductState.upsell.isUpsellAddedToCart || buildProductState.upsell.isUpsellDenied || youtubeInCart){
        if(InHomeUtils.isNotNull(buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(buildProductState.couponInfo.coupon) && buildProductState.couponInfo.referfriendvalidationsucess)
            proceedToCheckoutForRAF=buildProductAction.proceedToCheckoutForRAF(appState.visitId,lqState,buildProductState,cart,dispatch)? true :false;
        else if(InHomeUtils.isNotNull(buildProductState.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(buildProductState.ffCouponInfo.ffCoupon) && buildProductState.ffCouponInfo.ffValidationSucess)
            proceedToCheckoutForFF=buildProductAction.proceedToCheckoutForFF(appState.visitId,lqState,buildProductState,cart,dispatch)? true :false;
        else if (InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.vzcCouponInfo) && InHomeUtils.isNotNull(buildProductState.vzcCouponInfo.vzcValidationSuccess) && buildProductState.vzcCouponInfo.vzcValidationSuccess)
            proceedToCheckoutForVZC = buildProductAction.proceedToCheckoutForVZC(buildProductState, lqState, dispatch) ? true : false;
        if ((proceedToCheckoutForRAF && InHomeUtils.isNotNull(buildProductState.couponInfo.coupon) && InHomeUtils.isNotEmpty(buildProductState.couponInfo.coupon)  && buildProductState.couponInfo.referfriendvalidationsucess) ||(proceedToCheckoutForFF && InHomeUtils.isNotNull(buildProductState.ffCouponInfo.ffCoupon) && InHomeUtils.isNotEmpty(buildProductState.ffCouponInfo.ffCoupon) && buildProductState.ffCouponInfo.ffValidationSucess) || (proceedToCheckoutForVZC && InHomeUtils.isNotNull(buildProductState) && InHomeUtils.isNotNull(buildProductState.vzcCouponInfo) && InHomeUtils.isNotNull(buildProductState.vzcCouponInfo.vzcValidationSuccess) && buildProductState.vzcCouponInfo.vzcValidationSuccess)) {

            proceedToCheckout=true;
        }
        else if(!proceedToCheckoutForRAF||! proceedToCheckoutForFF ||!proceedToCheckoutForVZC)
        {
            proceedToCheckout=false;
        }
        if (proceedToCheckout) {
            buildProductAction.checkoutBtnSelection(dispatch, false);
            onCartClick("minicart");
        }

    }
    else {
        buildProductAction.fetchUpsellrecommendations(dispatch, appState.visitId,lqState.doFlowDetails.isDoFlow,lqState);
        cartActions.cartToggle("upsell_checkout", dispatch, appState.visitId,buildProductState);
    }
    if(lqState && lqState.runtimeKey && lqState.runtimeKey.isAllowFireAlarm == 'Y' && buildProductState.emergencyServices && buildProductState.emergencyServices.selectedProduct){
        buildProductAction.updateFireAlarmDetails(appState.visitId, buildProductState.emergencyServices);
    }
  }

  const onCartClick = (action = "", isCliked = "false") => {
    
    try {
      if (action !== "minicart") {
          if (cartState.isCartOpen) {
              updateSCTags("cart close");
              //hideChatWindow('');
              isMobile && handleToggleChatButton(false);
          }
          onCartSplitBillClick(0);
          setTimeout(() => {
            let dropdownIcon=document.getElementById("BillCartTop");
            if(dropdownIcon){
              dropdownIcon.focus();
            }
           }, 100);
      }
      else {
          updateSCTags("review order");
          logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.BYOB, appState.visitId, 'onCartCheckOutClick', "CHECKOUT-CARTCLICK", PAGEACTIVITY.UA));
          let isdigitalAdapterAvail = false
          if(buildProductState && buildProductState.dct!==null && buildProductState.dct!==undefined && buildProductState.dct.isDCTEligible !== undefined && buildProductState.dct.isDCTEligible === true){
              isdigitalAdapterAvail =true;
          }
          // setTimeout(() => {
          //   scbuildButtonNxtLinkTrack(cartState.cartResponse.tierContent[0],isdigitalAdapterAvail);
          // },3000);
          
      }


      
      if(cartState.splitBillTab>0){
        cartActions.splitBillTab(0, dispatch);
      }
      cartActions.cartToggle(action, dispatch, appState.visitId,buildProductState);
    
      if (action === "checkout") {
          checkoutAction.checkSatelliteEligible(dispatch, lqState.lqQualdetails,appState.visitId);
          let splitBillTab = cartState.splitBillTab;
          let autoPayinCart = false;
          let advantageOfferinCart = false;
          if (cartState.cartData[splitBillTab].Promotions !== undefined && cartState.cartData[splitBillTab].Promotions.promotions !== undefined
              && cartState.cartData[splitBillTab].Promotions.promotions !== null && cartState.cartData[splitBillTab].Promotions.promotions.length > 0) {
                cartState.cartData[splitBillTab].Promotions.promotions.map(function (product) {
                  if (InHomeUtils.isNotNull(product)  && InHomeUtils.isNotNull(product?.offerAttrValue) && (product?.offerAttrValue==="FCP_AUTOPAY_DISCOUNT" || product?.offerAttrValue?.includes?.("$10_AutoPay") || product?.offerAttrValue?.includes?.("$5_AutoPay")) && !product?.offerAttrValue?.toUpperCase?.()?.includes?.("DECLINE")) {
                      autoPayinCart = true;
                  }
              })
          }
          if (InHomeUtils.isNotNull(cartState.cartData[splitBillTab].rewardOffers) && InHomeUtils.isNotNull(cartState.cartData[splitBillTab].rewardOffers.rewardOffers)
              && cartState.cartData[splitBillTab].rewardOffers.rewardOffers.length > 0) {
                cartState.cartData[splitBillTab].rewardOffers.rewardOffers.map(function (product) {
                  if (InHomeUtils.isNotNull(product) && InHomeUtils.isNotEmpty(product.promoText) && product.promoText.indexOf("Mobile +") > -1) {
                      advantageOfferinCart = true;
                  }
              })
          }
          buildProductAction.autoPayinCart(autoPayinCart? true : false, dispatch);
          buildProductAction.advantageOfferinCart(advantageOfferinCart? true : false, dispatch);

          if (InHomeUtils.isNotNull(cartState.cartData[splitBillTab].oneTimeCharge) && InHomeUtils.isNotNull(cartState.cartData[splitBillTab].oneTimeCharge.onetimecharge)
            && cartState.cartData[splitBillTab].oneTimeCharge.onetimecharge.length > 0) {
            let setup = cartState.cartData[splitBillTab].oneTimeCharge.onetimecharge.filter(p => p.prodType === "SETUP")
            let setupcharge = cartState.isFiosSetupFee
            if (InHomeUtils.isNotNull(setup) && setup.length > 0 && InHomeUtils.isNotNull(setup[0].price)) {
                if (setup[0].price === "Included") {
                    if (setupcharge !== "FeeWaived") {
                        buildProductAction.fiosSetupFee('FeeWaived', dispatch)
                    }
                }
                else {
                    if (setupcharge !== "")
                        buildProductAction.fiosSetupFee('', dispatch)
                }
            }
          }
      }

      if(isMobile){
        setDraggedState(!!draggedState);
      }
          
    }
    catch (ex) {
      catchJSException('BuildProduct', appState.visitId, 'onCheckOutBtnkClick', ex);
    }
  }

  const onStreamCartClick = async (e) => {
    window.sessionStorage.setItem('minContinueclick',true); 
    onCloseMiniCart(true)
   
  }
  

  const onHandleReviewOrder = async() => {
    
      await dispatch({ type: "ON_CLICK_MINICART_ORDER_BUTTON", value: true });
      updateSCTags("review order");
      let splitBillTab = cartState?.splitBillTab || 0;
      let autoPayinCart = false;
      if (
        cartState?.cartData[splitBillTab]?.Promotions !== undefined &&
        cartState?.cartData[splitBillTab]?.Promotions?.promotions !== undefined &&
        cartState?.cartData[splitBillTab]?.Promotions?.promotions !== null &&
        cartState?.cartData[splitBillTab]?.Promotions?.promotions.length > 0
      ) {
        cartState?.cartData[splitBillTab]?.Promotions?.promotions.map(function (
          product
        ) {
          if (
            InHomeUtils.isNotNull(product) &&
            InHomeUtils.isNotNull(product?.offerAttrValue) &&
            (product?.offerAttrValue === "FCP_AUTOPAY_DISCOUNT" ||
              product?.offerAttrValue?.includes?.("$10_AutoPay") ||
              product?.offerAttrValue?.includes?.("$5_AutoPay") ||
              product?.offerAttrValue?.toLowerCase()?.indexOf("autopay") > -1)
            && product?.offerAttrValue?.toLowerCase?.()?.indexOf?.("decline") == -1
          ) {
            autoPayinCart = true;
          }
        });
      }
      buildProductAction.autoPayinCart(autoPayinCart ? true : false, dispatch);
      if(props?.lqState?.streamlineLQ){
        buildProductAction.checkoutBtnSelection(dispatch, false);
        onCartClick("minicart");
      }
      else{
        checkUpsellRecommendation();
      }
  
    
    
    // Introduced because of PRODDEF-38056
    // Check if Autopay is available in the cart on review order before checkout
     }
     //Commenting below code as i always disabling button in cart.
     const isGigPlan = buildProductState?.internet?.m2mPlans?.findIndex?.(item => ["R3582", "R3583"].includes(item?.id) || item?.name?.toUpperCase?.()?.includes?.("GIG")) > -1;
     const isMax500Plan = !isGigPlan && buildProductState?.internet?.m2mPlans?.findIndex?.(item => ["R3582", "R3583"].includes(item?.id) || item?.name?.toUpperCase?.()?.includes?.("GIG")) == -1;
     const internetcart = cartState?.cartData?.[0]?.serviceHeaders?.servicehead?.find(item=>item?.prodName.includes('Mbps'))?true:false;
     let disableReviewOrderBtn = (window.location.pathname && window.location.pathname.includes('streamlineordering') &&  ((!buildProductState?.internet?.selectedProduct?.equipmentOffers?.[0]?.includes("Data:100%") && !buildProductState?.splOffer?.selectedProduct === null) || buildProductState?.router?.selectedProduct ===null)) ? true : !buildProductState?.isenableCheckout;

     let groupBtnText = (!orderSumPage || isMovesFlowOSIthrottle) ? 'Review order' : 'Checkout';

     if(window.location.pathname && window.location.pathname.includes('streamlineordering')){
      if(((buildProductState?.sploffer?.offerplansMTM && buildProductState?.sploffer?.offerplansMTM.length>0 && buildProductState?.sploffer?.selectedProduct === null) || buildProductState?.router?.selectedProduct ===null))
      {
        disableReviewOrderBtn = false;
        groupBtnText = 'Continue';
      }

     }
     
     const buttonGroupObject = () => {
    let buttonObj = [];
    if (!checkoutPage && appState.flowType !== "SUPP") 
      buttonObj.push({
      children: groupBtnText,
      size: 'large',
      use: 'primary',
      width: '100%',
      disabled: disableReviewOrderBtn,
      onClick: (e) => groupBtnText === 'Continue' ? onStreamCartClick(e) :(!orderSumPage || isMovesFlowOSIthrottle) ? onHandleReviewOrder(true) : checkOutRedirection(),
   
    });
    !isMobile ?
    buttonObj.push({
      children: 'Close',
      size: 'large',
      use: !checkoutPage && appState.flowType !== "SUPP" ? 'secondary' : 'primary',
      width: ((!checkoutPage && appState.flowType !== "SUPP") || isMobile) ? '100%' : 'auto',
      onClick: (e) => onCartClick(e),
    })
   : '' 
   return buttonObj;
  }

  const onSaveCart=(e)=>{
    dispatch({type:'ENABLE_SAVECART_STICKY_MOBILE', value:true}); 
  }

  const openMiniCartModal = (newdragstate) =>{
     setDraggedState(newdragstate);         
          
  }

  const handleTouchStart = useCallback((e, swipteType) => {   
    setStartX(e.touches[0].clientX);
    setStartY(e.touches[0].clientY);
    setPosition({ x: e.touches[0].clientX, y: e.touches[0].clientY });   
    if(e.touches[0].clientY - e.touches[0].clientX > 2)
    {     
      if(swipteType === 'up') 
      {
        onCartClick(e);
        setDraggedState(false); 
      }         
           
    } 
}, []);

const handleTouchEnd = useCallback(
    (e,swipteType) => {
    
    const endX = e.changedTouches[0].clientX;
    const endY = e.changedTouches[0].clientY; 
    if(swipteType === 'up' ){      
      
      setPosition({ x: endX, y:  '30vh'});
    }
    else if(swipteType === 'down'){    
      onCartClick(e)
      setDraggedState(true);     
      setPosition({ x: 0, y: '30vh' });
      setStartX(0);
      setStartY(0);
      
    }     

    },
    [startX, startY],
);

const handleTouchMove = useCallback(
    (e, swipteType) => {
    
    const endX = e.changedTouches[0].clientX;
    const endY = e.changedTouches[0].clientY;  
    if(swipteType === 'up' ){  
    setPosition({ x: endX, y: endY < 275 ? '30vh' :endY }); 
    }
    else if(swipteType === 'down' ){
      setPosition({ x: endX, y: endY < 275 ? '30vh' :endY });
    }  
    
    },
    [startX, startY],
);


const onCloseMiniCart = (isclicked) => {

  onCartClick("", 'close');
  setDraggedState(true);  
  setPosition({ x: 0, y: '30vh' });
  setStartX(0);
  setStartY(0);   

}



 return (
    <React.Fragment>
      {/****Mobile view subheader */}
      <div draggable={true} style={{display:(isStickyCartHeader && draggedState && !progressbar ? 'block' : 'none')}} >
        <SaveMiniCart isMobile ={isMobile} btnData={btnData} openMiniCartModal={(newdragstate) =>openMiniCartModal(newdragstate)} isMiniSubHeader={draggedState} isStreamline={props?.lqState?.streamlineLQ?true:false}/>
      </div>


      {/****non Mobile and mobile drag view subheader */}
      <div style={{display:(!isMobile || isNonStickyCartHeader ? 'block':isMobile && !draggedState ? 'block' : 'none')}}>
        <div id="dvCart" className={`${dvCartClass} ${checkoutCartClass} ${dvCartSumarry}  ${isStickyCartHeader ? 'stickyCartFooterBordeRadius' : 'noBorderRadius'} ${isTablet ? 'tabletCart' : ''} dvMiniCart position-fixed`} data-drop-cart="" style={{
          position: isMobile && "absolute",
          top: isStickyCartHeader ? position.y :'',
          backgroundColor: isMobile && 'white',
          zIndex:100,
        }}
        >
          <div draggable="true" id="resultcartOrder" style={{ marginBottom: isMobile ? '70px' : '' }} className={`columns cart-custom-scrollbar ${checkoutCartClass} ${isStickyCartHeader ? StremlineMiniCartSticky : StremlineMiniCartContent} cartOrderData ${(currClient.browserType && currClient.browserType === 'safari') ? 'safariFooter' : ''} ${(isMobile && StremlineMiniCartMobileView) ? "stremLineMiniCartContent":""}`}>
            <div className='main padding-top-zero m_ordering-page orderSumMobileMargin' style={{ margin: !isMobile ? '10px' : '0px' }}>
              {isStickyCartHeader ?
                <div className="stickyCartHeader" >
                  <div className="appfbHeaderAlignment mobileOrderSummary" style={{ paddingTop: '10px' }}>
                    <div className="appfbFormAlign">
                      <div>
                        <Title size="XLarge">{(appState?.flowType==="MV" && moveExpState?.cust_opt==="SEAMLESS" ) ? "Your current plan." : "Your order."}</Title>
                      </div>
                    </div>
                   {appState?.flowType !== 'MV' &&
                     <div className="appfbFormAlign">
                       <div className="margin-top-micro" style={{ marginRight: isMobile ? '0px' : '-70px' }}>
                         <TextLink
                           type="standAlone"
                           size="small"
                           id="SAVE"
                           onClick={e => onSaveCart(e)}
                         >
                           Save cart
                         </TextLink>
                       </div>
                     </div>
                   }
                    <div className="appfbFormAlign" style={{ marginTop: "10px", paddingLeft: isMobile ? '0px' : '20px' }}>
                      <span onClick={(e) => {onCloseMiniCart(true)}} ><CloseIcon size="small" color='#000000' /></span>
                    </div>
                  </div>
                </div>
                :
                <div style={{ paddingTop: isMobile ? '6px' : (isTablet ? '0px' : '22px') }}>
                  <Title size="XLarge">{(appState?.flowType==="MV" && moveExpState?.cust_opt==="SEAMLESS") ? "Your current plan." : "Your order."}</Title>
                </div>}
              <div className={`checkoutMainContainer3425 ${isStickyCartHeader ? "" : ""} `}>
                <div className="checkoutLeftContainer234213">
                  {appState?.flowType === "MV" ? 
                  <>
                    <MovesReviewOrder linkEditTagCall={linkEditTagCall} flowtype ={appState?.flowType} showMovesOldCart={showMovesOldCart}/>
                    <MovesOrderSummary showMovesOldCart={showMovesOldCart}/>
                    
                  </>
                  :<>
                    <ReviewOrderReskin   linkEditTagCall={linkEditTagCall} flowtype ={''}/>
                    <OrderSummaryReskin/>
                  </>
                  }
                  <div className={isMobile ? isStickyCartHeader && (!props?.lqState?.streamlineLQ) ? 'hide' : `flaotingCTA-wrapper column flaotingCTAWrapperReskin ${(currClient.deviceType && currClient.deviceType === 'iphone') ? 'iphoneStickyCTA' : ''}` : StremlineMiniCart}>
                    <ButtonGroup childWidth={'100%'} viewport={'desktop'} rowQuantity={{ desktop: isMobile ? 1 : 2 }}
                      data={buttonGroupObject()}
                      alignment={!checkoutPage && appState.flowType !== "SUPP" ? 'center' : 'left'}
                    />
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
          {/* {props?.lqState?.streamlineLQ && <div className='stremlinebtn'>
             <ButtonGroup childWidth={'100%'} viewport={'desktop'} rowQuantity={{ desktop: isMobile ? 1 : 2 }}
                      data={buttonGroupObject()}
                      alignment={!checkoutPage && appState.flowType !== "SUPP" ? 'center' : 'left'}
                    />
          </div>} */}
        </div>
      </div>
      
      <div id="dvCart-back-overlaymini" 
      
       style={{ top: dtvMiniOverLayTopSetting, zIndex: props?.lqState?.streamlineLQ && !isMobile ? 7:1, display:(!isMobile ? 'block':(isMobile && !draggedState )? 'block' :  'none')}}><div style={{ height: isStickyCartHeader && "0vh", }} id="inner-background"></div></div>
      </React.Fragment>
  );
}

const mapStateToProps = state => {
    return {
      lqState: state.loopQual,
      appState: state.app, 
      cartState: state.cart, 
      profileCartState: state.profileCart, 
      buildProductState: state.buildProduct,   
      creditCheckState: state.creditCheck,   
      visitId: state.app.visitId,
      checkoutState: state.checkout,
      routerState: state.router,
      moveExpState: state.moveExp,
    }
  }
  
  export default React.memo(connect(mapStateToProps)(orderSum));